import type { ReactNode } from 'react';

import type { BoxProps } from '@m/components';

import {
  AlertModalBox,
  AlertModalIconBox,
  AlertModalContent,
} from './AlertModal.styled';
import { ModalBackground } from './Modals.styled';

interface AlertModalProps extends BoxProps {
  icon?: ReactNode;
  show?: boolean;
  onCancel?: () => void;
  children?: ReactNode;
}

export function AlertModal({
  icon,
  show = false,
  onCancel = () => {},
  children,
  ...modalContentProps
}: AlertModalProps) {
  return (
    <AlertModalBox show={show}>
      <ModalBackground onClick={onCancel} />
      <AlertModalContent
        show={show}
        {...modalContentProps}
      >
        {icon && (
          <AlertModalIconBox>{icon}</AlertModalIconBox>
        )}
        {children}
      </AlertModalContent>
    </AlertModalBox>
  );
}
